import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import PropTypes from "prop-types";

const DeleteConfirmationModel = ({ deleteConfirmOpen, handleDeleteDialogClose, handleDeleteConfirm }) => {
    return (
        <Dialog
            open={deleteConfirmOpen}
            onClose={(_, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                    handleDeleteDialogClose();
                }
            }}
            aria-labelledby="delete-email-dialog-title"
            PaperProps={{ sx: { borderRadius: 2, maxWidth: 300, m: 2 } }}
        >
            <DialogTitle
                id="delete-email-dialog-title"
                sx={{ fontSize: 14, fontWeight: 600, py: 1.25, px: 2, pb: 0.5 }}
            >
                Delete this email?
            </DialogTitle>
            <DialogContent sx={{ pt: 0, px: 2, pb: 1 }}>
                <Typography variant="caption" sx={{ fontSize: 11, color: "text.secondary" }}>
                    You cannot undo this.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 2, py: 1, gap: 0.75, justifyContent: "flex-end" }}>
                <Button size="small" onClick={handleDeleteDialogClose} sx={{ fontSize: 12, textTransform: "none" }}>
                    Cancel
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    color="error"
                    onClick={handleDeleteConfirm}
                    sx={{ fontSize: 12, textTransform: "none", minWidth: 72 }}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>

    )
}

DeleteConfirmationModel.propTypes = {
    deleteConfirmOpen: PropTypes.bool.isRequired,
    handleDeleteDialogClose: PropTypes.func.isRequired,
    handleDeleteConfirm: PropTypes.func.isRequired,
};

export default DeleteConfirmationModel